/** Creators working with an agency, as the public pages get them (`workingCreators` in server/join.ts). */
export interface WorkingCreators {
  /** Every creator working with the agency. */
  total: number;
  /** A shuffled pool of up to 20 with a real profile photo; name is a first name and last initial. */
  avatars: { name: string; image: string | null }[];
}

/** True when there are photos to show (the pages show something else otherwise). */
export const hasPhotos = (creators: WorkingCreators | null | undefined) => Boolean(creators?.avatars.some((c) => c.image));
